import React from 'react';

import {TableHeader} from '@pb/kit-component-data-table-v2';
import {Group, Item} from '@pb/kit-component-group';

import type {ReactNode} from 'react';

type Props = {
    selection: ReactNode,
    children: ReactNode,
};

export const MainColumnHeader: React.FC<Props> = ({children, selection}) => (
    <TableHeader indent="none" mainColumn={true} className="search-header">
        <Group gap="none" alignItems="center">
            <Item style={{width: 50}}>{selection}</Item>
            <Item grow={1}>{children}</Item>
        </Group>
    </TableHeader>
);
